import { IListApiRequest, IListApiResponse } from 'api/types'

export enum Channel {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  INAPP = 'INAPP'
}

export interface TokenRequest {
  phoneNumberId: string;
  wabaId: string;
  code: string;
  channel: Channel;
}
export interface AppChannel {
  appName: string;
  businessInfo: string;
  channel: string;
  userAccessToken?: string;
  senderId?: string;
  dltTemplateId?: string;
}
export interface FacebookBusinessResponse {
  appName: string;
  channel: string;
  businessInfo: string;
  channelId: string;
  id: string;
  name: string;
  owner_business_info?: {
    name: string,
    id: string
  };
}
export interface IListApiRequestWithChannel<T> extends IListApiRequest<T> {
  selectedChannel?: string;
}
export interface FBListParams {
  size?: number;
  page?: number;
  [key: string]: string | number | undefined;
}
export type AppChannelSaveRequest = AppChannel
export type AppChannelListRequest = IListApiRequest<AppChannel>
export type AppChannelListResponse = IListApiResponse<AppChannel>
